interface IDividerProps {
  text?: string;
  lineColor?: string;
  marginVertical?: string;
  size?: 'small' | 'medium';
  UNSAFE_className?: string;
}

const Divider = ({
  text,
  lineColor,
  size = 'medium',
  marginVertical,
  UNSAFE_className,
}: IDividerProps) => {
  if (!text)
    return (
      <hr
        className={`
    ${UNSAFE_className}
    divider
    tw-mx-auto tw-w-full tw-border-0 tw-border-b
    tw-border-solid tw-border-[#f5f5f5]
    ${
      marginVertical
        ? marginVertical
        : size === 'small'
        ? 'tw-my-2 desktop:tw-my-4'
        : size === 'medium'
        ? 'tw-my-4 desktop:tw-my-8'
        : ''
    }
  `}
      />
    );

  return (
    <>
      <div
        className={`divider tw-w-full$ ${marginVertical ? marginVertical : ''}`}
      >
        <p className="line tw-flex tw-items-center tw-justify-center">
          {text && <span className="tw-text-base tw-font-normal">{text}</span>}
        </p>
      </div>
      <style jsx>{`
        .line::before,
        .line::after {
          content: '';
          width: 100%;
          display: block;
          background: ${lineColor || 'var(--clr-grey-2)'};
          height: 1px;
        }

        .line::before {
          margin-right: ${text && '5%'};
        }

        .line::after {
          margin-left: ${text && '5%'};
        }
      `}</style>
    </>
  );
};

export default Divider;
